import { Link, useLocation } from "react-router-dom";
import Avatar from "./avatar";
import ReturnButton from "./return-button";

const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="px-6 flex items-center justify-between h-20">
      {location.pathname === "/" ? (
        <h1 className="font-bold text-xl">randomly</h1>
      ) : (
        <ReturnButton />
      )}
      <Link to={"/me"}>
        <Avatar />
      </Link>
    </nav>
  );
};

export default Navigation;
